<style lang="scss">
.bunding-email-safe .remind {
  text-align: center;
  color: #cccccc;
}
.bunding-email-safe .bombbox {
  width: 410px;
  box-sizing: border-box;
  border-radius: 10px;
  .el-dialog__body {
    box-sizing: border-box;
    width: 410px;
  }
}

.bunding-email-safe .input-form {
  margin-top: 20px;
  padding: 0 73px;
}
// @media (min-width: 768px) {
//   .bunding-email-safe .bombbox {
//     width: 410px;
//   }
//   .bunding-email-safe .input-form {
//     padding: 0 50px;
//   }
// }
.bunding-email-safe .yan-zh {
  width: 126px;
  margin-right: 20px;
}
.bunding-email-safe .get-button {
  text-align: center;
  width: 70px;
}
.bunding-email-safe .que-button {
  width: 120px;
}
.bunding-email-safe .footer {
  text-align: center;
}
</style>
<template>
  <div class="bunding-email-safe">
    <el-dialog
      :title="box_title"
      :visible.sync="myResult"
      size="tiny"
      label-width="0px"
      custom-class="bombbox"
    >
      <div class="remind" v-if="email&&change_email">确保更改绑定操作属用户本人操作</div>
      <div class="remind" v-else>绑定邮箱，可使用邮箱登录</div>
      <div v-if="email&&change_email">
        <el-form :model="form1" ref="form1" class="input-form" :rules="form1_rules">
          <el-form-item prop="value">
            <el-select
              v-model="value"
              placeholder="请选择安全验证方式"
              style="width: 100%"
              @change="changeValidateWay"
            >
              <el-option label="通过登录密码验证" value="1"></el-option>
              <el-option :label="'通过手机号'+phone+'验证'" value="2" v-if="phone"></el-option>
              <el-option :label="'通过邮箱'+email+'验证'" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="xx">
            <el-input
              v-model="form1.xx"
              :placeholder="xx_message"
              :class="{'yan-zh': value==2||value==3}"
              :type="value==1?'password':'text'"
            ></el-input>
            <el-button
              type="text"
              class="get-button AEE-tc"
              v-if="value==2"
              @click="getCaptcha"
              :disabled="phone_pb_disabled"
            >{{ phone_pb_show}}</el-button>
            <el-button
              type="text"
              class="get-button AEE-tc"
              v-if="value==3"
              @click="getCaptcha"
              :disabled="email_pb_disabled"
            >{{ email_pb_show}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-form :model="form2" ref="form2" class="input-form" :rules="from2_rules">
          <el-form-item prop="email">
            <el-input v-model="form2.email" placeholder="输入邮箱"></el-input>
          </el-form-item>
          <el-form-item prop="email_captcha">
            <el-input v-model="form2.email_captcha" placeholder="邮箱验证码" class="yan-zh"></el-input>
            <el-button
              type="text"
              class="get-button AEE-tc"
              @click="getCaptchaStep"
              :disabled="pb_disabled"
            >{{ pb_show}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button
          type="primary"
          size="large"
          class="que-button"
          @click="safeValidate"
          v-if="email&&change_email"
        >验证身份</el-button>
        <el-button type="primary" size="large" class="que-button" @click="postEmail" v-else>确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data: function() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      } else if (
        !this.$common.validEmail(value)
      ) {
        callback(new Error("邮箱号错误,请重新填写"));
      } else {
        callback();
      }
    };
    var validateEmailCaptcha = (rule, value, callback) => {
      if (this.type === 0) {
        callback();
      } else {
        if (value == "") {
          callback("请输入动态码");
        } else if (this.email_code_message != "") {
          callback(getErrorMessage(this.email_code_message));
          this.email_code_message = "";
        } else {
          callback();
        }
      }
    };
    var validateXx = (rule, value, callback) => {
      if (this.value == 1) {
        if (value == "") {
          callback("请输入密码");
        } else if (value.length < 6 && value.length > 26) {
          callback(new Error("请输入6-26位数字或字母"));
        } else if (this.xx_code_message != "") {
          callback(getErrorMessage(this.xx_code_message));
          this.xx_code_message = "";
        } else {
          callback();
        }
      } else {
        if (value == "") {
          callback("请输入动态码");
        }
        if (this.xx_code_message != "") {
          callback(getErrorMessage(this.xx_code_message));
          this.xx_code_message = "";
        } else {
          callback();
        }
      }
    };
    return {
      form1: {
        xx: ""
      },
      form2: {
        email: "",
        email_captcha: ""
      },
      form1_rules: {
        xx: [{ required: true, validator: validateXx, trigger: "change" }]
      },
      from2_rules: {
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        email_captcha: [
          { required: true, validator: validateEmailCaptcha, trigger: "blur" }
        ]
      },
      value: "1",
      xx_code_message: "",
      email_code_message: "",
      myResult: this.dialogFormVisible,
      type: 1,
      change_email: true,
      box_title: "安全验证",
      captcha_token: "",
      phone_pb_disabled: false,
      phone_pb_show: "获取验证码",
      email_pb_disabled: false,
      email_pb_show: "获取验证码",
      pb_disabled: false,
      pb_show: "获取验证码"
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: null
    },
    phone: {
      type: String,
      default: null
    }
  },
  watch: {
    dialogFormVisible(val) {
      this.myResult = val;
    },
    myResult(val) {
      this.change_email = true;
      this.box_title = "安全验证";
      if (this.$refs.form1 != null) this.$refs.form1.resetFields();
      if (this.$refs.form2 != null) this.$refs.form2.resetFields();
      this.$emit("on-result-change", val);
    },
    value() {
      if (this.$refs.form1 != null) this.$refs.form1.resetFields();
    },
    email(val) {
      if (val) {
        this.type = 0;
      } else {
        this.type = 1;
      }
    }
  },
  methods: {
    changeValidateWay: function() {
      this.form1.xx = null;
      if (this.$refs.form1 != null) this.$refs.form1.resetFields();
    },
    //安全验证
    safeValidate: function() {
      if (this.value == 1) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/md/e/sfck/v/p"), {
                pwd: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.type = 1;
                  this.box_title = "邮箱验证";
                  this.change_email = false;
                  if (this.$refs.form2 != null) this.$refs.form2.resetFields();
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      } else if (this.value == 2) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/u/vtm/ctm/te"), {
                ac: this.phone,
                dc: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.type = 1;
                  this.box_title = "邮箱验证";
                  this.change_email = false;
                  if (this.$refs.form2 != null) this.$refs.form2.resetFields();
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      } else if (this.value == 3) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/v/md/e/sfck/dc"), {
                ac: this.email,
                dc: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.type = 1;
                  this.box_title = "邮箱验证";
                  this.change_email = false;
                  if (this.$refs.form2 != null) this.$refs.form2.resetFields();
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      }
    },
    //第一步获取动态码
    getCaptcha: function() {
      if (this.value == 2) {
        this.$http
          .post(globalProvider.serviceUrl("ea/u/ect/bts/tmc"), {
            ac: this.phone,
            kv: {
              考试名称: this.$store.state.examInfo.currentExamInfo.exam_name
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.phone_pb_disabled = true;
              let time = 60;
              this.phone_pb_show = time + 1;
              for (let i = 0; i <= time; i++) {
                window.setTimeout(() => {
                  --this.phone_pb_show;
                  if (this.phone_pb_show == 0) {
                    this.phone_pb_show = "重新发送";
                    this.phone_pb_disabled = false;
                  }
                }, i * 1000);
              }
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示信息", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
      }
      if (this.value == 3) {
        this.$http
          .post(globalProvider.serviceUrl("ea/md/e/sfck/c/dc"), {
            ac: this.email
          })
          .then(data => {
            this.email_pb_disabled = true;
            let time = 60;
            if (data.body.code == resultCode.Success) {
              this.email_pb_show = time + 1;
              for (let i = 0; i <= time; i++) {
                window.setTimeout(() => {
                  --this.email_pb_show;
                  if (this.email_pb_show == 0) {
                    this.email_pb_show = "重新发送";
                    this.email_pb_disabled = false;
                  }
                }, i * 1000);
              }
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示信息", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
      }
    },
    //第二步获取动态码
    getCaptchaStep: function() {
      this.$refs.form2.validateField("email", valid => {
        if (valid == "") {
          this.$http
            .post(globalProvider.serviceUrl("ea/md/e/c/dc"), {
              ac: this.form2.email
            })
            .then(data => {
              this.pb_disabled = true;
              let time = 60;
              if (data.body.code == resultCode.Success) {
                this.pb_show = time + 1;
                for (let i = 0; i <= time; i++) {
                  window.setTimeout(() => {
                    --this.pb_show;
                    if (this.pb_show == 0) {
                      this.pb_show = "重新发送";
                      this.pb_disabled = false;
                    }
                  }, i * 1000);
                }
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message), "提示信息", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            });
        }
      });
    },
    postEmail: function() {
      this.$refs.form2.validate(valid => {
        if (valid) {
          this.$http
            .post(globalProvider.serviceUrl("ea/md/e"), {
              na: this.form2.email,
              dc: this.form2.email_captcha,
              tk: this.captcha_token
            })
            .then(data => {
              if (data.body.code == resultCode.Success) {
                this.myResult = false;
              }
              if (data.body.code == resultCode.NotSuccess) {
                this.email_code_message = data.body.message;
                this.$refs.form2.validateField("email_captcha");
              }
            });
        }
      });
    }
  },
  computed: {
    xx_message: function() {
      if (this.value == 1) {
        return "登录密码";
      } else if (this.value == 2) {
        return "短信验证码";
      } else if (this.value == 3) {
        return "邮箱验证码";
      }
    }
  }
};
</script>